/** D-172: a writing or speaking section of a free mock waiting for the day's AI budget: said plainly
 * on the score card, never « marking in progress ». The work is saved and corrected later. */

import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

export function AiUnavailable() {
  const { t } = useTranslation();
  return (
    <p className="ac-status ac-secondary ac-score__pending">
      <Info aria-hidden size={18} />
      {t("freeMock.delayedShort")}
    </p>
  );
}
